import React from 'react';
import GridContainer from '../../Componant/UiKits/Grid';

const Grid = () => {
  return (
    <div className='page-body'>
      <GridContainer />
    </div>
  );
};

export default Grid;
